<div class="booking_details_df" *ngIf="!loader && _entityDetails.length > 0">
  <div class="welcome_heading">
    <h3>
      {{
        _entityDetails[0].entityName && _entityDetails[0].entityName != "null"
          ? _entityDetails[0].entityName
          : "No name added"
      }}
    </h3>
    <p>{{ _entityDetails[0].addressInfo.address_line }}</p>
  </div>
  <!--  -->
  <div class="row">
    <div class="col-sm-8">
      <div class="row">
        <div
          class="col-sm-4"
          *ngIf="
            _entityDetails[0].shopServiceStatus != 2 &&
            _entityDetails[0].revenue_model == 1 &&
            getSectionVisibleStatus('Shop/In-Premise operation')
          "
        >
          <div class="booking_card_tt">
            <mat-card (click)="openBookings('1')">
              <div class="price_gd">
                <h4>{{ entityFeatureWiseCounts?.today_shop_bookings }}</h4>
              </div>
              <div class="booking_icon">
                <img
                  src="../../../../assets/images/Shop-Bookings.png"
                  alt="icon"
                />
              </div>
              <div class="booking_headingtt">
                <h3>Shop service</h3>
                <p>Manage your in-shop bookings for today and tomorrow.</p>
              </div>
              <div class="onhover_arrow">
                <mat-icon class="hover-icon"> arrow_forward</mat-icon>
              </div>
            </mat-card>
          </div>
        </div>

        <div
          class="col-sm-4"
          *ngIf="
            _entityDetails[0].homeServiceStatus != 2 &&
            _entityDetails[0].revenue_model == 1 &&
            getSectionVisibleStatus('Home service operation')
          "
        >
          <div class="booking_card_tt">
            <mat-card (click)="openBookings('0')">
              <div class="price_gd">
                <h4>{{ entityFeatureWiseCounts?.today_home_bookings }}</h4>
              </div>
              <div class="booking_icon">
                <img
                  src="../../../../assets/images/Home-Bookings.png"
                  alt="icon"
                />
              </div>
              <div class="booking_headingtt">
                <h3>Home service</h3>
                <p>Your home service bookings for today and tomorrow.</p>
              </div>
              <div class="onhover_arrow">
                <mat-icon class="hover-icon"> arrow_forward</mat-icon>
              </div>
            </mat-card>
          </div>
        </div>
        <div
          class="col-sm-4"
          *ngIf="
            _entityDetails[0].virtual_service_status != 2 &&
            _entityDetails[0].revenue_model == 1 &&
            getSectionVisibleStatus('Virtual service operation')
          "
        >
          <div class="booking_card_tt">
            <mat-card (click)="openBookings('2')">
              <div class="price_gd">
                <h4>{{ entityFeatureWiseCounts?.today_virtual_bookings }}</h4>
              </div>
              <div class="booking_icon">
                <img
                  src="../../../../assets/images/virtual-bookings.png"
                  alt="icon"
                />
              </div>
              <div class="booking_headingtt">
                <h3>Virtual service</h3>
                <p>Your virtual service bookings for today and tomorrow.</p>
              </div>
              <div class="onhover_arrow">
                <mat-icon class="hover-icon"> arrow_forward</mat-icon>
              </div>
            </mat-card>
          </div>
        </div>
        <div
          class="col-sm-4"
          *ngIf="
            _entityDetails[0].revenue_model == 1 &&
            getSectionVisibleStatus('Booking history')
          "
        >
          <div class="booking_card_tt">
            <mat-card (click)="openBookingHistory()">
              <div class="price_gd">
                <h4>{{ entityFeatureWiseCounts?.total_bookings }}</h4>
              </div>
              <div class="booking_icon">
                <img
                  src="../../../../assets/images/All-bookings.png"
                  alt="icon"
                />
              </div>
              <div class="booking_headingtt">
                <h3>All activity</h3>
                <p>All past, present, future bookings and queries.</p>
              </div>
              <div class="onhover_arrow">
                <mat-icon class="hover-icon"> arrow_forward</mat-icon>
              </div>
            </mat-card>
          </div>
        </div>

        <div
          class="col-sm-4"
          *ngIf="
            _entityDetails[0].shopServiceStatus != 2 &&
            _entityDetails[0].revenue_model == 2 &&
            getSectionVisibleStatus('Shop/In-Premise operation')
          "
        >
          <div class="booking_card_tt" (click)="openJoiningQueryList('1')">
            <mat-card>
              <div class="price_gd">
                <h4>{{ entityFeatureWiseCounts?.shop_enroll_requests }}</h4>
              </div>
              <div class="booking_icon">
                <img
                  src="../../../../assets/images/in-permise.png"
                  alt="icon"
                />
              </div>
              <div class="booking_headingtt">
                <h3>In-premise</h3>
                <p>Bookings, joining queries in-premise or centre.</p>
              </div>
              <div class="onhover_arrow">
                <mat-icon class="hover-icon"> arrow_forward</mat-icon>
              </div>
            </mat-card>
          </div>
        </div>

        <div
          class="col-sm-4"
          *ngIf="
            _entityDetails[0].homeServiceStatus != 2 &&
            _entityDetails[0].revenue_model == 2 &&
            getSectionVisibleStatus('Home service operation')
          "
        >
          <div class="booking_card_tt" (click)="openJoiningQueryList('0')">
            <mat-card>
              <div class="price_gd">
                <h4>{{ entityFeatureWiseCounts?.home_enroll_requests }}</h4>
              </div>
              <div class="booking_icon">
                <img
                  src="../../../../assets/images/house-of-mirrors.png"
                  alt="icon"
                />
              </div>
              <div class="booking_headingtt">
                <h3>Home service</h3>
                <p>Bookings, joining queries in home service.</p>
              </div>
              <div class="onhover_arrow">
                <mat-icon class="hover-icon"> arrow_forward</mat-icon>
              </div>
            </mat-card>
          </div>
        </div>

        <div
          class="col-sm-4"
          *ngIf="
            _entityDetails[0].virtual_service_status != 2 &&
            _entityDetails[0].revenue_model == 2 &&
            getSectionVisibleStatus('Virtual service operation')
          "
        >
          <div class="booking_card_tt" (click)="openJoiningQueryList('2')">
            <mat-card>
              <div class="price_gd">
                <h4>{{ entityFeatureWiseCounts?.virtual_enroll_requests }}</h4>
              </div>
              <div class="booking_icon">
                <img
                  src="../../../../assets/images/customer-service-agent.png"
                  alt="icon"
                />
              </div>
              <div class="booking_headingtt">
                <h3>Virtual service</h3>
                <p>Bookings, joining queries in virtual service.</p>
              </div>
              <div class="onhover_arrow">
                <mat-icon class="hover-icon"> arrow_forward</mat-icon>
              </div>
            </mat-card>
          </div>
        </div>

        <div
          class="col-sm-4"
          *ngIf="
            _entityDetails[0].revenue_model == 2 &&
            getSectionVisibleStatus('Booking history')
          "
        >
          <div class="booking_card_tt" (click)="openJoiningQueryList('4')">
            <mat-card>
              <div class="price_gd">
                <h4>
                  {{
                    entityFeatureWiseCounts?.total_enroll_requests +
                      entityFeatureWiseCounts?.total_bookings +
                      entityFeatureWiseCounts?.total_member_attendance
                  }}
                </h4>
              </div>
              <div class="booking_icon">
                <img
                  src="../../../../assets/images/join-hands.png"
                  alt="icon"
                />
              </div>
              <div class="booking_headingtt">
                <h3>All activity</h3>
                <p>All past, present, future bookings and queries.</p>
              </div>
              <div class="onhover_arrow">
                <mat-icon class="hover-icon"> arrow_forward</mat-icon>
              </div>
            </mat-card>
          </div>
        </div>

        <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 1">
          <div class="booking_card_tt">
            <mat-card (click)="openExpenses()">
              <div class="price_gd">
                <!-- <h4>{{entityFeatureWiseCounts?.today_expense.toFixed(2)}}</h4> -->
                <h4>{{ entityFeatureWiseCounts?.today_expense }}</h4>
              </div>
              <div class="booking_icon">
                <img src="../../../../assets/images/Expenses.png" alt="icon" />
              </div>
              <div class="booking_headingtt">
                <h3>Expenses</h3>
                <p>Track and add expenditures here. Prevent misuse of funds.</p>
              </div>
              <div class="onhover_arrow">
                <mat-icon class="hover-icon"> arrow_forward</mat-icon>
              </div>
            </mat-card>
          </div>
        </div>
        <div
          class="col-sm-4"
          *ngIf="getSectionVisibleStatus('Purchase handling')"
        >
          <div class="booking_card_tt">
            <mat-card (click)="openPurchaseList()">
              <div class="price_gd">
                <!-- <h4>{{entityFeatureWiseCounts?.today_purchases.toFixed(2)}}</h4> -->
                <h4>{{ entityFeatureWiseCounts?.today_purchases }}</h4>
              </div>
              <div class="booking_icon">
                <img src="../../../../assets/images/Purchase.png" alt="icon" />
              </div>
              <div class="booking_headingtt">
                <h3>Purchase</h3>
                <p>Check and add new purchase. See purchase requests.</p>
              </div>
              <div class="onhover_arrow">
                <mat-icon class="hover-icon"> arrow_forward</mat-icon>
              </div>
            </mat-card>
          </div>
        </div>
        <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 1">
          <div class="booking_card_tt">
            <mat-card (click)="openFeedback()">
              <div class="price_gd">
                <h4>{{ entityFeatureWiseCounts?.business_rating }}</h4>
              </div>
              <div class="booking_icon">
                <img src="../../../../assets/images/Feedback.png" alt="icon" />
              </div>
              <div class="booking_headingtt">
                <h3>Feedback</h3>
                <p>See customer responses. Check areas of improvement.</p>
              </div>
              <div class="onhover_arrow">
                <mat-icon class="hover-icon"> arrow_forward</mat-icon>
              </div>
            </mat-card>
          </div>
        </div>
        <div
          class="col-sm-4"
          *ngIf="getSectionVisibleStatus('Invoice history')"
        >
          <div class="booking_card_tt">
            <mat-card (click)="openInvoices()">
              <div class="price_gd">
                <h4>{{ entityFeatureWiseCounts?.invoices_count }}</h4>
              </div>
              <div class="booking_icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="512"
                  height="512"
                  x="0"
                  y="0"
                  viewBox="0 0 512 512"
                  style="enable-background: new 0 0 512 512"
                  xml:space="preserve"
                  class=""
                >
                  <g>
                    <path
                      d="M141.388 43.676a7.5 7.5 0 0 0-13.672 4.262v42.166c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5V71.996l14.84 21.489c2.083 3.013 5.735 4.331 9.081 3.286 3.451-1.077 5.682-4.254 5.682-8.164l-.395-40.821a7.5 7.5 0 0 0-7.498-7.428h-.074a7.5 7.5 0 0 0-7.428 7.572l.18 18.503zM114.229 90.104V47.858c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v42.245c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.499zM300.878 40.358a7.499 7.499 0 0 0-7.5 7.5v42.245c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5V47.858a7.5 7.5 0 0 0-7.5-7.5zM405.271 55.552c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-17.638a7.499 7.499 0 0 0-7.5 7.5V89.91c0 4.143 3.357 7.5 7.5 7.5h17.638c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-10.138v-5.929h8.837c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-8.837v-5.93h10.138zM349.073 55.358c2.73 0 5.362.803 7.611 2.322a7.5 7.5 0 0 0 8.396-12.43 28.487 28.487 0 0 0-16.008-4.893c-15.783 0-28.623 12.84-28.623 28.623 0 15.782 12.84 28.622 28.623 28.622 6.373 0 12.106-2.107 16.578-6.092a24.62 24.62 0 0 0 2.478-2.554 7.5 7.5 0 0 0-11.498-9.634 9.282 9.282 0 0 1-.955.986c-1.708 1.522-3.93 2.294-6.603 2.294-7.512 0-13.623-6.11-13.623-13.622s6.113-13.622 13.624-13.622zM201.627 97.604h.056c3.596-.024 6.789-2.327 7.964-5.782l13.794-41.521a7.497 7.497 0 0 0-4.753-9.481 7.499 7.499 0 0 0-9.481 4.753l-7.715 23.222-8.121-23.395c-1.358-3.914-5.634-5.988-9.544-4.626a7.5 7.5 0 0 0-4.626 9.544l14.461 41.661a8.456 8.456 0 0 0 7.965 5.625zM281.213 68.981c0-15.783-12.84-28.623-28.622-28.623s-28.622 12.84-28.622 28.623c0 15.782 12.84 28.622 28.622 28.622s28.622-12.839 28.622-28.622zm-42.244 0c0-7.512 6.11-13.623 13.622-13.623s13.622 6.111 13.622 13.623-6.11 13.622-13.622 13.622-13.622-6.11-13.622-13.622zM307.543 136.201c0 4.143 3.357 7.5 7.5 7.5h90.229c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-90.229a7.5 7.5 0 0 0-7.5 7.5zM405.271 161.838h-38.533c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h38.533c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5zM395.271 453.771c-2.233 0-3.635-1.576-6.986-6.64-3.522-5.32-8.845-13.36-19.494-13.36s-15.972 8.04-19.494 13.36c-3.352 5.063-4.753 6.64-6.986 6.64-2.235 0-3.637-1.577-6.99-6.641-3.521-5.32-8.845-13.359-19.495-13.359s-15.974 8.04-19.496 13.359c-3.353 5.063-4.754 6.641-6.988 6.641-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5c10.65 0 15.974-8.04 19.496-13.359 3.353-5.063 4.754-6.641 6.988-6.641s3.636 1.576 6.988 6.641c3.523 5.319 8.847 13.359 19.497 13.359 10.649 0 15.972-8.04 19.494-13.36 3.352-5.063 4.753-6.64 6.986-6.64s3.635 1.576 6.986 6.64c3.522 5.32 8.845 13.36 19.494 13.36 4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5z"
                      fill="#c00c22"
                      opacity="1"
                      data-original="#000000"
                      class=""
                    ></path>
                    <path
                      d="M450.209 380.021a7.499 7.499 0 0 0-7.5 7.5v92.25c0 9.5-7.729 17.229-17.229 17.229H86.52c-9.5 0-17.229-7.729-17.229-17.229V32.229C69.291 22.729 77.02 15 86.52 15h52.321c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5H86.52C68.749 0 54.291 14.458 54.291 32.229v447.543c0 17.77 14.458 32.228 32.229 32.228h338.96c17.771 0 32.229-14.458 32.229-32.229v-92.25a7.5 7.5 0 0 0-7.5-7.5zM425.48 0H168.828c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5H425.48c9.5 0 17.229 7.729 17.229 17.229v325.306c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5V32.229C457.709 14.458 443.251 0 425.48 0z"
                      fill="#c00c22"
                      opacity="1"
                      data-original="#000000"
                      class=""
                    ></path>
                    <path
                      d="M109.908 221.355v155.778c0 9.714 7.902 17.616 17.616 17.616h73.805c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-73.805a2.62 2.62 0 0 1-2.616-2.616v-38.836h189.509v41.452h-83.101c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h153.16c9.714 0 17.616-7.902 17.616-17.616V221.355c0-9.714-7.902-17.616-17.616-17.616H127.524c-9.713 0-17.616 7.903-17.616 17.616zm17.616-2.616h186.893v41.453H124.908v-38.837a2.62 2.62 0 0 1 2.616-2.616zm-2.616 104.559v-48.105h189.509v48.105zm262.185 0h-57.676v-48.105h57.676zm-2.616 56.452h-55.06v-41.452h57.676v38.836a2.62 2.62 0 0 1-2.616 2.616zm2.616-158.395v38.837h-57.676v-41.453h55.06a2.62 2.62 0 0 1 2.616 2.616z"
                      fill="#c00c22"
                      opacity="1"
                      data-original="#000000"
                      class=""
                    ></path>
                  </g>
                </svg>
              </div>
              <div class="booking_headingtt">
                <h3>Bills / Invoices</h3>
                <p>Create new and see existing bills or invoices.</p>
              </div>
              <div class="onhover_arrow">
                <mat-icon class="hover-icon"> arrow_forward</mat-icon>
              </div>
            </mat-card>
          </div>
        </div>

        <div
          class="col-sm-4"
          *ngIf="
            _entityDetails[0].is_owner == 0 &&
            getSectionVisibleStatus('Customer management')
          "
        >
          <div class="booking_card_tt">
            <mat-card (click)="openCustomers()">
              <div class="price_gd">
                <h4>{{ entityFeatureWiseCounts?.total_customers }}</h4>
              </div>
              <div class="booking_icon">
                <img
                  src="../../../../assets/images/customer-service.png"
                  alt="icon"
                />
              </div>
              <div class="booking_headingtt">
                <h3>Customers</h3>
                <p>List of your customers. See profiles, pending payments.</p>
              </div>
              <div class="onhover_arrow">
                <mat-icon class="hover-icon"> arrow_forward</mat-icon>
              </div>
            </mat-card>
          </div>
        </div>
        <div
          class="col-sm-4"
          *ngIf="
            _entityDetails[0].is_owner == 0 &&
            getSectionVisibleStatus('Member management')
          "
        >
          <div class="booking_card_tt">
            <mat-card (click)="openMembers()">
              <div class="price_gd">
                <h4>{{ entityFeatureWiseCounts?.enrolled_members }}</h4>
              </div>
              <div class="booking_icon">
                <img src="../../../../assets/images/teamwork.png" alt="icon" />
              </div>
              <div class="booking_headingtt">
                <h3>Members</h3>
                <p>List of your members. See profiles, pending payments.</p>
              </div>
              <div class="onhover_arrow">
                <mat-icon class="hover-icon"> arrow_forward</mat-icon>
              </div>
            </mat-card>
          </div>
        </div>
      </div>
      <!-- Operation settings start -->
      <div class="opration_section_o">
        <div class="welcome_heading">
          <h3>Operation settings</h3>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="booking_card_tt">
              <mat-card (click)="openServices()">
                <div class="price_gd">
                  <h4>{{ entityFeatureWiseCounts?.total_services }}</h4>
                </div>
                <div class="booking_icon">
                  <img
                    src="../../../../assets/images/Service-list.png"
                    alt="icon"
                  />
                </div>
                <div class="booking_headingtt">
                  <h3>Services / Packages</h3>
                  <p>
                    Manage and add services for this business. Add discount.
                  </p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="booking_card_tt">
              <mat-card (click)="openProducts()">
                <div class="price_gd">
                  <h4>{{ entityFeatureWiseCounts?.product_count }}</h4>
                </div>
                <div class="booking_icon">
                  <img
                    src="../../../../assets/images/products-list01.png"
                    alt="icon"
                  />
                </div>
                <div class="booking_headingtt">
                  <h3>Product list</h3>
                  <p>
                    Manage and add products for this business. Add discount.
                  </p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>
          <div
            class="col-sm-4"
            *ngIf="_entityDetails[0].shopServiceStatus != 2"
          >
            <div class="booking_card_tt">
              <mat-card (click)="openServiceTimings('1')">
                <div class="price_gd">
                  <mat-icon
                    class="ic"
                    *ngIf="entityFeatureWiseCounts?.shop_timings == 1"
                    >check</mat-icon
                  >
                </div>
                <div class="booking_icon">
                  <img
                    src="../../../../assets/images/Shop-timings.png"
                    alt="icon"
                  />
                </div>
                <div class="booking_headingtt">
                  <h3>Shop timings</h3>
                  <p>Control service hours and booking slots for your shop.</p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>
          <div
            class="col-sm-4"
            *ngIf="_entityDetails[0].homeServiceStatus != 2"
          >
            <div class="booking_card_tt">
              <mat-card (click)="openServiceTimings('0')">
                <div class="price_gd">
                  <mat-icon
                    class="ic"
                    *ngIf="entityFeatureWiseCounts?.home_timings == 1"
                    >check</mat-icon
                  >
                </div>
                <div class="booking_icon">
                  <img
                    src="../../../../assets/images/Home-timings.png"
                    alt="icon"
                  />
                </div>
                <div class="booking_headingtt">
                  <h3>Home timings</h3>
                  <p>Service hours and booking slots for home service.</p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>
          <div
            class="col-sm-4"
            *ngIf="_entityDetails[0].virtual_service_status != 2"
          >
            <div class="booking_card_tt">
              <mat-card (click)="openServiceTimings('2')">
                <div class="price_gd">
                  <mat-icon
                    class="ic"
                    *ngIf="entityFeatureWiseCounts?.virtual_timings == 1"
                    >check</mat-icon
                  >
                </div>
                <div class="booking_icon">
                  <img
                    src="../../../../assets/images/virtual-timings.png"
                    alt="icon"
                  />
                </div>
                <div class="booking_headingtt">
                  <h3>Virtual timings</h3>
                  <p>
                    Control service hours of your video call/virtual services.
                  </p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>
          <div
            class="col-sm-4"
            *ngIf="getSectionVisibleStatus('Inventory management')"
          >
            <div class="booking_card_tt">
              <mat-card (click)="openInventory()">
                <div class="price_gd">
                  <h4>{{ entityFeatureWiseCounts?.total_inventory_items }}</h4>
                </div>
                <div class="booking_icon">
                  <img
                    src="../../../../assets/images/Inventory.png"
                    alt="icon"
                  />
                </div>
                <div class="booking_headingtt">
                  <h3>Inventory</h3>
                  <p>
                    Check items and their current stock status. Add new one.
                  </p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>

          <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 1">
            <div class="booking_card_tt">
              <mat-card (click)="openDiscount()">
                <div class="price_gd">
                  <h4>
                    {{
                      entityFeatureWiseCounts?.today_discount
                        ? entityFeatureWiseCounts?.today_discount
                        : "0.00"
                    }}
                  </h4>
                </div>
                <div class="booking_icon">
                  <img
                    src="../../../../assets/images/Bill-discount.png"
                    alt="icon"
                  />
                </div>
                <div class="booking_headingtt">
                  <h3>Bill discount</h3>
                  <p>Manage discounts for your customers over bill amount.</p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>
          <!-- <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 1">
            <div class="booking_card_tt">
              <mat-card (click)="openQRCode()">
                <div class="price_gd">
                  <mat-icon
                    class="ic"
                    *ngIf="entityFeatureWiseCounts?.qr_code == 1"
                    >check</mat-icon
                  >
                </div>
                <div class="booking_icon">
                  <img src="../../../../assets/images/QR-code.png" alt="icon" />
                </div>
                <div class="booking_headingtt">
                  <h3>QR code</h3>
                  <p>
                    Next generation quick booking process for your customers.
                  </p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div> -->
        </div>
      </div>
      <!-- Operation settings end -->
      <!-- Advanced functionaly start -->
      <div class="opration_section_o">
        <div class="welcome_heading">
          <h3>
            {{
              _entityDetails[0].is_owner == 1
                ? "Advanced functionality"
                : "My data"
            }}
          </h3>
        </div>
        <div class="row">
          <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 1">
            <div class="booking_card_tt">
              <mat-card (click)="openCustomers()">
                <div class="price_gd">
                  <h4>{{ entityFeatureWiseCounts?.total_customers }}</h4>
                </div>
                <div class="booking_icon">
                  <img
                    src="../../../../assets/images/customer-service.png"
                    alt="icon"
                  />
                </div>
                <div class="booking_headingtt">
                  <h3>Customers</h3>
                  <p>List of your customers. See profiles, pending payments.</p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>
          <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 1">
            <div class="booking_card_tt">
              <mat-card (click)="openMembers()">
                <div class="price_gd">
                  <h4>{{ entityFeatureWiseCounts?.enrolled_members }}</h4>
                </div>
                <div class="booking_icon">
                  <img
                    src="../../../../assets/images/teamwork.png"
                    alt="icon"
                  />
                </div>
                <div class="booking_headingtt">
                  <h3>Members</h3>
                  <p>List of your members. See profiles, pending payments.</p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>
          <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 1">
            <div class="booking_card_tt">
              <mat-card (click)="openEmployees()">
                <div class="price_gd">
                  <h4>{{ entityFeatureWiseCounts?.total_employees }}</h4>
                </div>
                <div class="booking_icon">
                  <img
                    src="../../../../assets/images/employee011.png"
                    alt="icon"
                  />
                </div>
                <div class="booking_headingtt">
                  <h3>Employees</h3>
                  <p>Manage employees, salary, credits. Check attendance.</p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>
          <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 1">
            <div class="booking_card_tt">
              <mat-card (click)="openTaxAndGST()">
                <div class="price_gd">
                  <mat-icon
                    class="ic"
                    *ngIf="entityFeatureWiseCounts?.tax_status == 1"
                    >check</mat-icon
                  >
                </div>
                <div class="booking_icon">
                  <img
                    src="../../../../assets/images/tax-gst-01.png"
                    alt="icon"
                  />
                </div>
                <div class="booking_headingtt">
                  <h3>{{ isEntityForeign == "0" ? "Tax & GST" : "Taxes" }}</h3>
                  <p>
                    {{
                      isEntityForeign == "0"
                        ? "Control your taxes. Configure GST, service tax and others."
                        : "Control your taxes. Configure tax and other deductions."
                    }}
                  </p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>

          <!-- new card -->
          <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 1">
            <div class="booking_card_tt">
              <mat-card (click)="openloyaltyconfigure()">
                <div class="price_gd">
                  <mat-icon
                    class="ic"
                    *ngIf="entityFeatureWiseCounts?.reward_config_status == 1"
                    >check</mat-icon
                  >
                </div>
                <div class="booking_icon">
                  <img
                    src="../../../../assets/images/loyalty-program.png"
                    alt="icon"
                  />
                </div>
                <div class="booking_headingtt">
                  <h3>Loyalty Rewards</h3>
                  <p>Manage loyalty rewards, retain customers and members.</p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>

          <!-- new card end -->
          <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 1">
            <div class="booking_card_tt">
              <mat-card (click)="openOnlinePayments()">
                <div class="price_gd">
                  <mat-icon
                    class="ic"
                    *ngIf="entityFeatureWiseCounts?.online_payment_status == 1"
                    >check</mat-icon
                  >
                </div>
                <div class="booking_icon">
                  <img
                    src="../../../../assets/images/mobile-banking.png"
                    alt="icon"
                  />
                </div>
                <div class="booking_headingtt">
                  <h3>Online Payments</h3>
                  <p>Configure online payments for your services.</p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>
          <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 1">
            <div class="booking_card_tt">
              <mat-card (click)="openCoupons()">
                <div class="price_gd">
                  <h4>{{ entityFeatureWiseCounts?.total_active_coupons }}</h4>
                </div>
                <div class="booking_icon">
                  <img
                    src="../../../../assets/images/Coupon-discount.png"
                    alt="icon"
                  />
                </div>
                <div class="booking_headingtt">
                  <h3>Coupon discount</h3>
                  <p>Generate coupon code. Give discount to your customers.</p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>

          <!-- <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 1">
            <div class="booking_card_tt">
              <mat-card (click)="openFollowers()">
                <div class="price_gd">
                  <h4>{{ entityFeatureWiseCounts?.total_followers }}</h4>
                </div>
                <div class="booking_icon">
                  <img
                    src="../../../../assets/images/follow-91.png"
                    alt="icon"
                  />
                </div>
                <div class="booking_headingtt">
                  <h3>Followers</h3>
                  <p>Get to know about the fan followings of this business.</p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div> -->
          <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 1">
            <div class="booking_card_tt">
              <mat-card (click)="openBusinessPost()">
                <div class="price_gd">
                  <h4>{{ entityFeatureWiseCounts?.total_posts }}</h4>
                </div>
                <div class="booking_icon">
                  <img
                    src="../../../../assets/images/Business-Post.png"
                    alt="icon"
                  />
                </div>
                <div class="booking_headingtt">
                  <h3>Business Post</h3>
                  <p>Posts created by your business on LookzUp.</p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>
          <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 1">
            <div class="booking_card_tt">
              <mat-card (click)="openpromotioncampaign()">
                <div class="price_gd">
                  <h4>{{ entityFeatureWiseCounts?.campaign_count }}</h4>
                </div>
                <div class="booking_icon">
                  <img
                    src="../../../../assets/images/marketing.png"
                    alt="icon"
                  />
                </div>
                <div class="booking_headingtt">
                  <h3>Promotion</h3>
                  <p>Create and send promotional advertisement messages.</p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>

          <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 1">
            <div class="booking_card_tt">
              <mat-card (click)="openReports()">
                <div class="booking_icon">
                  <img
                    src="../../../../assets/images/report-chart.png"
                    alt="icon"
                  />
                </div>
                <div class="booking_headingtt">
                  <h3>Reports</h3>
                  <p>
                    Several insight data on the performance of the business.
                  </p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>
          <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 1">
            <div class="booking_card_tt">
              <mat-card (click)="openSupportTicket()">
                <div class="price_gd">
                  <h4>{{ entityFeatureWiseCounts?.total_support_tickets }}</h4>
                </div>
                <div class="booking_icon">
                  <img
                    src="../../../../assets/images/support-ticket-1.png"
                    alt="icon"
                  />
                </div>
                <div class="booking_headingtt">
                  <h3>Support Ticket</h3>
                  <p>
                    Premium support to get quick troubleshoot for your issues.
                  </p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>

          <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 0">
            <div class="booking_card_tt">
              <mat-card (click)="openMySalary()">
                <div class="price_gd">
                  <!-- <h4>0</h4> -->
                </div>
                <div class="booking_icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="512"
                    height="512"
                    x="0"
                    y="0"
                    viewBox="0 0 48 48"
                    style="enable-background: new 0 0 512 512"
                    xml:space="preserve"
                    class=""
                  >
                    <g>
                      <g data-name="THR (money in envelope)">
                        <path
                          d="M48 22.85c-.09-.59-.11-.47-4.13-3.1 3.57-13.41 3.49-12.63 3.2-13.14S47.3 6.37 36 3.34V1a1 1 0 0 0-1-1H13a1 1 0 0 0-1 1v2.34L1.54 6.14a1 1 0 0 0-.71 1.23l3.32 12.38c-3.94 2.57-4 2.49-4.12 3C0 23 0 21.89 0 44a4 4 0 0 0 4 4h40a4 4 0 0 0 4-4V22.85Zm-13.95 9.79 12-7.79c0 20.91 0 19.26-.07 19.66ZM45.17 23l-2.66 1.73.79-2.95ZM45 7.82c-.52 1.94 1.87-7-5 18.55L36 29V9.55l2.31.62a3.07 3.07 0 0 0 1.29 2.24l-1.34 5a1 1 0 0 0 1.94.52l1.55-5.79a1 1 0 0 0-.75-1.23 1 1 0 0 1-.7-1.23 1 1 0 0 0-.71-1.23L36 7.48V5.41ZM34 2v28.28l-10 6.53-10-6.53V2ZM2.07 44.51C2 44.11 2 45.73 2 24.85l12 7.79ZM12 5.41v2.07l-3.63 1a1 1 0 0 0-.71 1.23 1 1 0 0 1-.66 1.2 1 1 0 0 0-.71 1.22l1.51 5.79a1 1 0 0 0 1.94-.52l-1.34-5a3.07 3.07 0 0 0 1.29-2.24L12 9.55V29l-4-2.63c-.76-2.82-4.22-15.73-5-18.55ZM5.49 24.73 2.83 23l1.87-1.22Zm-2 21.2 12.17-12.18c8.08 5.28 8.11 5.6 8.89 5.09l7.79-5.09 12.17 12.18c-.51.13-40.61.07-41.02 0Z"
                          fill="#06bc1e"
                          opacity="1"
                          data-original="#000000"
                          class=""
                        ></path>
                        <path
                          d="M18 13V7.83A3 3 0 0 0 19.83 6h8.34A3 3 0 0 0 30 7.83V13a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1 1 1 0 0 1-1-1 1 1 0 0 0-1-1H19a1 1 0 0 0-1 1 1 1 0 0 1-1 1 1 1 0 0 0-1 1v6a1 1 0 0 0 2 0Z"
                          fill="#06bc1e"
                          opacity="1"
                          data-original="#000000"
                          class=""
                        ></path>
                        <path
                          d="M24 30a8 8 0 1 0-8-8 8 8 0 0 0 8 8Zm0-14a6 6 0 1 1-6 6 6 6 0 0 1 6-6ZM23.62 9.08A1 1 0 1 0 25 10a1 1 0 0 0-1.38-.92Z"
                          fill="#06bc1e"
                          opacity="1"
                          data-original="#000000"
                          class=""
                        ></path>
                      </g>
                    </g>
                  </svg>
                </div>
                <div class="booking_headingtt">
                  <h3>My salary</h3>
                  <p>
                    List of your salaries credited to you so far with detail
                    data.
                  </p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>
          <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 0">
            <div class="booking_card_tt">
              <mat-card (click)="openMyCredits()">
                <div class="price_gd">
                  <!-- <h4>0</h4> -->
                </div>
                <div class="booking_icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="512"
                    height="512"
                    x="0"
                    y="0"
                    viewBox="0 0 512 512"
                    style="enable-background: new 0 0 512 512"
                    xml:space="preserve"
                    class=""
                  >
                    <g>
                      <path
                        d="M303.06 320.87c69.87 0 126.71-53.93 126.71-120.22 0-50.89-34.57-102.1-88.07-130.45-1.4-.74-1.97-2.4-1.34-3.86l14.88-34.47c4.01-9.28 1.68-20.04-5.79-26.77-6.63-5.95-16.1-6.74-23.59-1.94l-4.18 2.69c-1.26.8-2.59.81-3.83.01l-4.3-2.75c-6.48-4.14-14.53-4.14-20.99 0l-4.32 2.75c-1.24.79-2.56.79-3.78.01l-4.24-2.73c-7.47-4.79-16.95-4.01-23.58 1.95-7.47 6.73-9.79 17.49-5.79 26.77l14.89 34.49c.63 1.44.05 3.09-1.35 3.83-53.5 28.36-88.07 79.56-88.07 130.45 0 66.31 56.86 120.24 126.74 120.24zM265.53 25.53c-1.31-3.03-.6-6.38 1.8-8.55.71-.63 1.54-.96 2.37-.96.64 0 1.28.19 1.87.57l4.27 2.75c6.5 4.13 14.55 4.12 21-.01l4.32-2.75c1.23-.79 2.54-.79 3.78 0l4.3 2.75c6.46 4.13 14.51 4.14 21.05-.02l4.21-2.71c1.38-.89 3.01-.74 4.25.37 2.41 2.17 3.12 5.53 1.81 8.55l-14.88 34.46c-.97 2.23-1.47 4.54-1.57 6.82-5.23 1.12-10.99 1.71-17 1.71-8.43 0-16.72-1.21-23.34-3.39-.67-.22-1.35-.34-2.02-.38-.23-1.61-.67-3.2-1.34-4.75zm6.35 58.79a18.81 18.81 0 0 0 5.61-4.55c.4.21.81.4 1.26.55 8.31 2.75 18.12 4.2 28.36 4.2 8.26 0 16.23-.96 23.38-2.78 1.11.98 2.34 1.86 3.71 2.59 48.34 25.62 79.57 71.28 79.57 116.33 0 57.47-49.67 104.23-110.72 104.23-61.07 0-110.75-46.76-110.75-104.23.01-45.06 31.24-90.72 79.58-116.34zm-8.32 137.38 66.5-66.5a7.991 7.991 0 0 1 11.3 11.3l-66.5 66.5c-1.56 1.56-3.61 2.34-5.65 2.34s-4.09-.78-5.65-2.34a7.991 7.991 0 0 1 0-11.3zm12.08-31.55c5.85 0 11.71-2.22 16.17-6.66 4.32-4.32 6.7-10.06 6.7-16.17s-2.38-11.85-6.7-16.17c-8.92-8.91-23.42-8.92-32.34 0l-.01.01c-8.87 8.91-8.87 23.4.03 32.34 4.46 4.43 10.3 6.65 16.15 6.65zm-4.85-27.71a6.85 6.85 0 0 1 4.85-2.01c1.84 0 3.56.72 4.86 2.02s2.02 3.03 2.02 4.86c0 1.84-.72 3.56-2 4.85-2.69 2.68-7.07 2.68-9.73.03-2.67-2.69-2.67-7.06 0-9.75zm43.48 43.5c-4.33 4.33-6.71 10.08-6.7 16.19.01 6.1 2.39 11.83 6.7 16.12 4.32 4.32 10.06 6.7 16.17 6.7s11.85-2.38 16.17-6.7c8.89-8.89 8.89-23.37 0-32.31-4.32-4.32-10.06-6.7-16.17-6.7s-11.85 2.38-16.17 6.7zm21.04 21.01c-1.3 1.3-3.03 2.02-4.86 2.02s-3.56-.72-4.88-2.03c-1.29-1.28-2-2.99-2-4.82 0-1.84.71-3.57 2.02-4.87 1.3-1.3 3.03-2.02 4.86-2.02s3.56.72 4.85 2c2.67 2.69 2.67 7.05.01 9.72zm168.33 160.52c-4.05-12.06-18.28-22.54-46.06-15.77l-98.62 23.99c-3.92-4.08-9.43-7.51-16.78-9.67l-124.13-36.45c-23.32-6.86-45.21-7.53-68.89-2.11l-32.07 7.32v-11.24c0-9.82-7.99-17.8-17.8-17.8H24.87c-9.83 0-17.83 7.99-17.83 17.8V486.3c0 9.82 8 17.8 17.83 17.8H99.3c9.82 0 17.8-7.99 17.8-17.8v-10.59l105.34 30.57c13.13 3.82 25.99 5.73 38.71 5.73 18.05 0 35.81-3.85 53.64-11.57l166.34-72.06c17.75-7.69 27.63-25.66 22.51-40.91zM101.12 486.3c0 .98-.83 1.81-1.81 1.81H24.87c-1 0-1.84-.83-1.84-1.81V343.55c0-.98.84-1.81 1.84-1.81H99.3c.97 0 1.81.85 1.81 1.81V486.3zm373.66-72.59-166.34 72.06c-26.83 11.62-53.5 13.31-81.54 5.16l-109.8-31.86v-87.88l35.63-8.13c21.19-4.85 39.94-4.28 60.82 1.86l124.13 36.45c5.74 1.69 9.27 4.28 11.21 7.13.11.21.24.41.37.61 1.61 2.72 1.85 5.62 1.2 8.19-1.7 6.69-9.46 12.6-22.49 9.78L202.65 399.9c-4.31-.94-8.57 1.8-9.51 6.12-.94 4.31 1.8 8.57 6.12 9.51l125.32 27.18c3.45.75 6.72 1.09 9.82 1.09 16.98 0 28.46-10.43 31.55-22.55.88-3.45 1.06-7.18.45-10.9l94.97-23.1c14.44-3.52 24.83-1.48 27.12 5.33 2.15 6.39-2.85 16.42-13.71 21.13z"
                        fill="#bc0606"
                        opacity="1"
                        data-original="#000000"
                      ></path>
                    </g>
                  </svg>
                </div>
                <div class="booking_headingtt">
                  <h3>My credits</h3>
                  <p>The list of credits, advance payments and payback data.</p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>
          <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 0">
            <div class="booking_card_tt">
              <mat-card (click)="openMyAttendance()">
                <div class="price_gd">
                  <!-- <h4>0</h4> -->
                </div>
                <div class="booking_icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="512"
                    height="512"
                    x="0"
                    y="0"
                    viewBox="0 0 682.667 682.667"
                    style="enable-background: new 0 0 512 512"
                    xml:space="preserve"
                    class=""
                  >
                    <g>
                      <defs>
                        <clipPath id="b" clipPathUnits="userSpaceOnUse">
                          <path
                            d="M0 512h512V0H0Z"
                            fill="#20bdc2"
                            opacity="1"
                            data-original="#000000"
                            class=""
                          ></path>
                        </clipPath>
                      </defs>
                      <mask id="a">
                        <rect
                          width="100%"
                          height="100%"
                          fill="#ffffff"
                          opacity="1"
                          data-original="#ffffff"
                        ></rect>
                        <path
                          d="M0 0c-11.046 0-20-8.954-20-20s8.954-20 20-20 20 8.954 20 20S11.046 0 0 0"
                          style="
                            fill-opacity: 1;
                            fill-rule: nonzero;
                            stroke: none;
                          "
                          transform="matrix(1.33333 0 0 -1.33333 166.667 253.333)"
                          fill="#ffffff"
                          data-original="#ffffff"
                        ></path>
                        <path
                          d="M0 0c-11.046 0-20-8.954-20-20s8.954-20 20-20 20 8.954 20 20S11.046 0 0 0"
                          style="
                            fill-opacity: 1;
                            fill-rule: nonzero;
                            stroke: none;
                          "
                          transform="matrix(1.33333 0 0 -1.33333 282.667 253.333)"
                          fill="#ffffff"
                          data-original="#ffffff"
                        ></path>
                        <path
                          d="M0 0c-11.046 0-20-8.954-20-20s8.954-20 20-20 20 8.954 20 20S11.046 0 0 0"
                          style="
                            fill-opacity: 1;
                            fill-rule: nonzero;
                            stroke: none;
                          "
                          transform="matrix(1.33333 0 0 -1.33333 398.667 253.333)"
                          fill="#ffffff"
                          data-original="#ffffff"
                        ></path>
                        <path
                          d="M0 0c-11.046 0-20-8.954-20-20s8.954-20 20-20 20 8.954 20 20S11.046 0 0 0"
                          style="
                            fill-opacity: 1;
                            fill-rule: nonzero;
                            stroke: none;
                          "
                          transform="matrix(1.33333 0 0 -1.33333 514.667 253.333)"
                          fill="#ffffff"
                          data-original="#ffffff"
                        ></path>
                        <path
                          d="M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20S0-11.046 0 0"
                          style="
                            fill-opacity: 1;
                            fill-rule: nonzero;
                            stroke: none;
                          "
                          transform="matrix(1.33333 0 0 -1.33333 193.333 396)"
                          fill="#ffffff"
                          data-original="#ffffff"
                        ></path>
                        <path
                          d="M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20S0-11.046 0 0"
                          style="
                            fill-opacity: 1;
                            fill-rule: nonzero;
                            stroke: none;
                          "
                          transform="matrix(1.33333 0 0 -1.33333 193.333 512)"
                          fill="#ffffff"
                          data-original="#ffffff"
                        ></path>
                        <path
                          d="M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20S0-11.046 0 0"
                          style="
                            fill-opacity: 1;
                            fill-rule: nonzero;
                            stroke: none;
                          "
                          transform="matrix(1.33333 0 0 -1.33333 309.333 396)"
                          fill="#ffffff"
                          data-original="#ffffff"
                        ></path>
                        <path
                          d="M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20S0-11.046 0 0"
                          style="
                            fill-opacity: 1;
                            fill-rule: nonzero;
                            stroke: none;
                          "
                          transform="matrix(1.33333 0 0 -1.33333 309.333 512)"
                          fill="#ffffff"
                          data-original="#ffffff"
                        ></path>
                        <path
                          d="M0 0c-11.046 0-20-8.954-20-20s8.954-20 20-20 20 8.954 20 20S11.046 0 0 0"
                          style="
                            fill-opacity: 1;
                            fill-rule: nonzero;
                            stroke: none;
                          "
                          transform="matrix(1.33333 0 0 -1.33333 282.667 253.333)"
                          fill="#ffffff"
                          data-original="#ffffff"
                        ></path>
                        <path
                          d="M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20S0-11.046 0 0"
                          style="
                            fill-opacity: 1;
                            fill-rule: nonzero;
                            stroke: none;
                          "
                          transform="matrix(1.33333 0 0 -1.33333 309.333 396)"
                          fill="#ffffff"
                          data-original="#ffffff"
                        ></path>
                        <path
                          d="M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20S0-11.046 0 0"
                          style="
                            fill-opacity: 1;
                            fill-rule: nonzero;
                            stroke: none;
                          "
                          transform="matrix(1.33333 0 0 -1.33333 309.333 512)"
                          fill="#ffffff"
                          data-original="#ffffff"
                        ></path>
                        <path
                          d="M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20S0-11.046 0 0"
                          style="
                            fill-opacity: 1;
                            fill-rule: nonzero;
                            stroke: none;
                          "
                          transform="matrix(1.33333 0 0 -1.33333 425.333 396)"
                          fill="#ffffff"
                          data-original="#ffffff"
                        ></path>
                        <path
                          d="M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20S0-11.046 0 0"
                          style="
                            fill-opacity: 1;
                            fill-rule: nonzero;
                            stroke: none;
                          "
                          transform="matrix(1.33333 0 0 -1.33333 541.333 396)"
                          fill="#ffffff"
                          data-original="#ffffff"
                        ></path>
                      </mask>
                      <g mask="url(#a)">
                        <g
                          clip-path="url(#b)"
                          transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                        >
                          <path
                            d="M0 0h-168c-33.137 0-60 26.863-60 60v312c0 33.137 26.863 60 60 60h352c33.137 0 60-26.863 60-60V230"
                            style="
                              stroke-width: 40;
                              stroke-linecap: round;
                              stroke-linejoin: round;
                              stroke-miterlimit: 10;
                              stroke-dasharray: none;
                              stroke-opacity: 1;
                            "
                            transform="translate(248 20)"
                            fill="none"
                            stroke="#20bdc2"
                            stroke-width="40"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-dasharray="none"
                            stroke-opacity=""
                            data-original="#000000"
                            opacity="1"
                            class=""
                          ></path>
                          <path
                            d="M0 0c-11.046 0-20-8.954-20-20s8.954-20 20-20 20 8.954 20 20S11.046 0 0 0"
                            style="
                              fill-opacity: 1;
                              fill-rule: nonzero;
                              stroke: none;
                            "
                            transform="translate(125 322)"
                            fill="#20bdc2"
                            data-original="#000000"
                            opacity="1"
                            class=""
                          ></path>
                          <path
                            d="M0 0c-11.046 0-20-8.954-20-20s8.954-20 20-20 20 8.954 20 20S11.046 0 0 0"
                            style="
                              fill-opacity: 1;
                              fill-rule: nonzero;
                              stroke: none;
                            "
                            transform="translate(212 322)"
                            fill="#20bdc2"
                            data-original="#000000"
                            opacity="1"
                            class=""
                          ></path>
                          <path
                            d="M0 0c-11.046 0-20-8.954-20-20s8.954-20 20-20 20 8.954 20 20S11.046 0 0 0"
                            style="
                              fill-opacity: 1;
                              fill-rule: nonzero;
                              stroke: none;
                            "
                            transform="translate(299 322)"
                            fill="#20bdc2"
                            data-original="#000000"
                            opacity="1"
                            class=""
                          ></path>
                          <path
                            d="M0 0c-11.046 0-20-8.954-20-20s8.954-20 20-20 20 8.954 20 20S11.046 0 0 0"
                            style="
                              fill-opacity: 1;
                              fill-rule: nonzero;
                              stroke: none;
                            "
                            transform="translate(386 322)"
                            fill="#20bdc2"
                            data-original="#000000"
                            opacity="1"
                            class=""
                          ></path>
                          <path
                            d="M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20S0-11.046 0 0"
                            style="
                              fill-opacity: 1;
                              fill-rule: nonzero;
                              stroke: none;
                            "
                            transform="translate(145 215)"
                            fill="#20bdc2"
                            data-original="#000000"
                            opacity="1"
                            class=""
                          ></path>
                          <path
                            d="M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20S0-11.046 0 0"
                            style="
                              fill-opacity: 1;
                              fill-rule: nonzero;
                              stroke: none;
                            "
                            transform="translate(145 128)"
                            fill="#20bdc2"
                            data-original="#000000"
                            opacity="1"
                            class=""
                          ></path>
                          <path
                            d="M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20S0-11.046 0 0"
                            style="
                              fill-opacity: 1;
                              fill-rule: nonzero;
                              stroke: none;
                            "
                            transform="translate(232 215)"
                            fill="#20bdc2"
                            data-original="#000000"
                            opacity="1"
                            class=""
                          ></path>
                          <path
                            d="M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20S0-11.046 0 0"
                            style="
                              fill-opacity: 1;
                              fill-rule: nonzero;
                              stroke: none;
                            "
                            transform="translate(232 128)"
                            fill="#20bdc2"
                            data-original="#000000"
                            opacity="1"
                            class=""
                          ></path>
                          <path
                            d="M0 0c-11.046 0-20-8.954-20-20s8.954-20 20-20 20 8.954 20 20S11.046 0 0 0"
                            style="
                              fill-opacity: 1;
                              fill-rule: nonzero;
                              stroke: none;
                            "
                            transform="translate(212 322)"
                            fill="#20bdc2"
                            data-original="#000000"
                            opacity="1"
                            class=""
                          ></path>
                          <path
                            d="M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20S0-11.046 0 0"
                            style="
                              fill-opacity: 1;
                              fill-rule: nonzero;
                              stroke: none;
                            "
                            transform="translate(232 215)"
                            fill="#20bdc2"
                            data-original="#000000"
                            opacity="1"
                            class=""
                          ></path>
                          <path
                            d="M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20S0-11.046 0 0"
                            style="
                              fill-opacity: 1;
                              fill-rule: nonzero;
                              stroke: none;
                            "
                            transform="translate(232 128)"
                            fill="#20bdc2"
                            data-original="#000000"
                            opacity="1"
                            class=""
                          ></path>
                          <path
                            d="M0 0v-80"
                            style="
                              stroke-width: 40;
                              stroke-linecap: round;
                              stroke-linejoin: round;
                              stroke-miterlimit: 10;
                              stroke-dasharray: none;
                              stroke-opacity: 1;
                            "
                            transform="translate(125 492)"
                            fill="none"
                            stroke="#20bdc2"
                            stroke-width="40"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-dasharray="none"
                            stroke-opacity=""
                            data-original="#000000"
                            opacity="1"
                            class=""
                          ></path>
                          <path
                            d="M0 0v80"
                            style="
                              stroke-width: 40;
                              stroke-linecap: round;
                              stroke-linejoin: round;
                              stroke-miterlimit: 10;
                              stroke-dasharray: none;
                              stroke-opacity: 1;
                            "
                            transform="translate(386 412)"
                            fill="none"
                            stroke="#20bdc2"
                            stroke-width="40"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-dasharray="none"
                            stroke-opacity=""
                            data-original="#000000"
                            opacity="1"
                            class=""
                          ></path>
                          <path
                            d="M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20S0-11.046 0 0"
                            style="
                              fill-opacity: 1;
                              fill-rule: nonzero;
                              stroke: none;
                            "
                            transform="translate(319 215)"
                            fill="#20bdc2"
                            data-original="#000000"
                            opacity="1"
                            class=""
                          ></path>
                          <path
                            d="M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20S0-11.046 0 0"
                            style="
                              fill-opacity: 1;
                              fill-rule: nonzero;
                              stroke: none;
                            "
                            transform="translate(406 215)"
                            fill="#20bdc2"
                            data-original="#000000"
                            opacity="1"
                            class=""
                          ></path>
                          <path
                            d="M0 0v-80"
                            style="
                              stroke-width: 40;
                              stroke-linecap: round;
                              stroke-linejoin: round;
                              stroke-miterlimit: 10;
                              stroke-dasharray: none;
                              stroke-opacity: 1;
                            "
                            transform="translate(255 492)"
                            fill="none"
                            stroke="#20bdc2"
                            stroke-width="40"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-dasharray="none"
                            stroke-opacity=""
                            data-original="#000000"
                            opacity="1"
                            class=""
                          ></path>
                          <path
                            d="m0 0 63.821-62.281c13.322-12.681 34.638-11.26 46.158 3.076l98.982 138.261"
                            style="
                              stroke-width: 40;
                              stroke-linecap: round;
                              stroke-linejoin: round;
                              stroke-miterlimit: 10;
                              stroke-dasharray: none;
                              stroke-opacity: 1;
                            "
                            transform="translate(283.039 90.944)"
                            fill="none"
                            stroke="#20bdc2"
                            stroke-width="40"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-dasharray="none"
                            stroke-opacity=""
                            data-original="#000000"
                            opacity="1"
                            class=""
                          ></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <div class="booking_headingtt">
                  <h3>My attendance</h3>
                  <p>
                    Your In and Out data along with the location information.
                  </p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>
          <div class="col-sm-4" *ngIf="_entityDetails[0].is_owner == 0">
            <div class="booking_card_tt">
              <mat-card (click)="openMessages()">
                <div class="price_gd">
                  <!-- <h4></h4> -->
                </div>
                <div class="booking_icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="512"
                    height="512"
                    x="0"
                    y="0"
                    viewBox="0 0 511.999 511.999"
                    style="enable-background: new 0 0 512 512"
                    xml:space="preserve"
                    class=""
                  >
                    <g>
                      <path
                        d="M510.156 401.843 480.419 315.3c14.334-29.302 21.909-61.89 21.96-94.679.088-57.013-21.97-110.92-62.112-151.79-40.15-40.878-93.652-63.889-150.652-64.792-59.105-.934-114.661 21.548-156.428 63.314-40.274 40.273-62.612 93.366-63.319 150.102-39.694 29.886-63.123 76.481-63.046 126.25.037 23.29 5.279 46.441 15.212 67.376L1.551 470.689c-3.521 10.247-.949 21.373 6.713 29.035 5.392 5.393 12.501 8.264 19.812 8.264 3.076 0 6.188-.508 9.223-1.551l59.609-20.483c20.935 9.933 44.086 15.175 67.376 15.212h.248c50.51-.002 97.46-24.035 127.237-64.702 30.987-.816 61.646-8.317 89.363-21.876l86.544 29.738a33.696 33.696 0 0 0 10.959 1.843c8.688 0 17.136-3.412 23.545-9.822 9.104-9.105 12.16-22.326 7.976-34.504zM164.53 470.69h-.199c-20.614-.031-41.085-5.113-59.196-14.695a15.244 15.244 0 0 0-12.078-.942l-61.123 21.003 21.003-61.122a15.24 15.24 0 0 0-.942-12.078c-9.582-18.112-14.664-38.582-14.696-59.197-.051-33.159 12.848-64.588 35.405-88.122 7.368 44.916 28.775 86.306 61.957 118.898 32.937 32.351 74.339 52.949 119.011 59.683-23.588 23.249-55.384 36.572-89.142 36.572zm316.098-55.893c-.867.867-1.895 1.103-3.051.705l-92.648-31.836a15.232 15.232 0 0 0-12.077.942c-26.453 13.994-56.345 21.416-86.447 21.462h-.288c-100.863 0-184.176-81.934-185.774-182.773-.805-50.785 18.513-98.514 54.394-134.395 35.881-35.881 83.618-55.192 134.396-54.392 100.936 1.601 182.926 85.068 182.77 186.063-.047 30.102-7.468 59.995-21.461 86.446a15.24 15.24 0 0 0-.942 12.078l31.835 92.648c.397 1.16.159 2.187-.707 3.052z"
                        fill="#d313b1"
                        opacity="1"
                        data-original="#000000"
                        class=""
                      ></path>
                      <path
                        d="M376.892 139.512h-181.56c-8.416 0-15.238 6.823-15.238 15.238 0 8.416 6.823 15.238 15.238 15.238h181.56c8.416 0 15.238-6.823 15.238-15.238s-6.822-15.238-15.238-15.238zM376.892 202.183h-181.56c-8.416 0-15.238 6.823-15.238 15.238s6.823 15.238 15.238 15.238h181.56c8.416 0 15.238-6.823 15.238-15.238s-6.822-15.238-15.238-15.238zM307.004 264.852H195.331c-8.416 0-15.238 6.823-15.238 15.238 0 8.416 6.823 15.238 15.238 15.238h111.672c8.416 0 15.238-6.823 15.238-15.238s-6.821-15.238-15.237-15.238z"
                        fill="#d313b1"
                        opacity="1"
                        data-original="#000000"
                        class=""
                      ></path>
                    </g>
                  </svg>
                </div>
                <div class="booking_headingtt">
                  <h3>Send message</h3>
                  <p>Communicate with your employer or this business owner.</p>
                </div>
                <div class="onhover_arrow">
                  <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
              </mat-card>
            </div>
          </div>
        </div>
      </div>
      <!-- Advanced functionaly end -->
    </div>
    <div class="col-sm-4">
      <div class="salon_mei_section">
        <mat-card>
          <div class="exert_opd">
            <div class="salon_img">
              <img
                [src]="businessDefaultImage"
                onerror="
                  this.src = '../../../../assets/images/entity_placeholder.png'
                "
                alt=""
                *ngIf="_entityDetails[0].revenue_model == 1"
              />
              <img
                [src]="businessDefaultImage"
                onerror="
                  this.src = '../../../../assets/images/fitness-placeholder.png'
                "
                alt=""
                *ngIf="_entityDetails[0].revenue_model == 2"
              />
            </div>

            <div class="hair_ct_heading">
              <div class="option_ser">
                <button mat-icon-button [matMenuTriggerFor]="homeMenu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #homeMenu="matMenu">
                  <button
                    mat-menu-item
                    (click)="viewdetailsv()"
                    *ngIf="_entityDetails[0].is_owner == 1"
                  >
                    <mat-icon class="material-icons-outlined">add_business</mat-icon>
                    Business setup
                  </button>
                  <button
                    mat-menu-item
                    (click)="openQRCode()"
                    *ngIf="_entityDetails[0].is_owner == 1"
                  >
                    <mat-icon class="material-icons-outlined">qr_code_2</mat-icon>
                    Business Kiosk QR
                  </button>
                  <button (click)="shareBusiness()" mat-menu-item>
                    <mat-icon class="material-icons-outlined">public</mat-icon
                    >Your business website
                  </button>
                  <button
                    (click)="openDocuments()"
                    mat-menu-item
                    *ngIf="_entityDetails[0].is_owner == 1"
                  >
                    <mat-icon class="material-icons-outlined"
                      >description</mat-icon
                    >Business documents
                  </button>
                  <button
                    mat-menu-item
                    (click)="openPlanAndRenew()"
                    *ngIf="_entityDetails[0].is_owner == 1"
                  >
                    <mat-icon class="material-icons-outlined">subject</mat-icon
                    >Current pack & recharge
                  </button>
                </mat-menu>
              </div>
              <h4
                style="
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  width: 80%;
                "
              >
                {{
                  _entityDetails[0].entityName &&
                  _entityDetails[0].entityName != "null"
                    ? _entityDetails[0].entityName
                    : "No name added"
                }}
              </h4>
              <p
                style="
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  width: 85%;
                "
              >
                Service: {{ _entityDetails[0].entity_services | servToStr }}
              </p>
              <p>
                {{
                  _entityDetails[0].entityPhone
                    ? _entityDetails[0].entity_country_code +
                      " " +
                      _entityDetails[0].entityPhone
                    : "No phone info"
                }}
              </p>
            </div>
            <div
              class="manj_sectiom"
              *ngIf="
                _entityDetails[0].shopServiceStatus != 2 &&
                _entityDetails[0].is_owner == 1
              "
            >
              <div class="shop_service_sec">
                <h4>Shop booking online</h4>
              </div>
              <div class="srd_fft">
                <mat-slide-toggle
                  (change)="onToggleChange($event, 1)"
                  [checked]="toShowCheckShop === 1"
                ></mat-slide-toggle>
              </div>
            </div>
            <div
              class="manj_sectiom"
              *ngIf="
                _entityDetails[0].homeServiceStatus != 2 &&
                _entityDetails[0].is_owner == 1
              "
            >
              <div class="shop_service_sec">
                <h4>Home booking online</h4>
              </div>
              <div class="srd_fft">
                <mat-slide-toggle
                  (change)="onToggleChange($event, 0)"
                  [checked]="toShowCheckHome === 1"
                ></mat-slide-toggle>
              </div>
            </div>
            <div
              class="manj_sectiom"
              *ngIf="
                _entityDetails[0].virtual_service_status != 2 &&
                _entityDetails[0].is_owner == 1
              "
            >
              <div class="shop_service_sec">
                <h4>Virtual online booking</h4>
              </div>
              <div class="srd_fft">
                <mat-slide-toggle
                  (change)="onToggleChange($event, 2)"
                  [checked]="toShowCheckVirtual === 1"
                ></mat-slide-toggle>
              </div>
            </div>
            <div class="manj_sectiom" *ngIf="_entityDetails[0].is_owner == 0">
              <div class="shop_service_sec">
                <h4>Duty status</h4>
              </div>
              <div class="srd_fft">
                <mat-slide-toggle
                  [(ngModel)]="toShowCheckDutyStatus"
                  (change)="onChangeDutyStatus($event)"
                  [checked]="toShowCheckDutyStatus === 1"
                ></mat-slide-toggle>
              </div>
            </div>
          </div>

          <div *ngIf="_entityDetails[0].is_owner == 1">
            <div
              class="active_cardt"
              *ngIf="
                _entityDetails[0].isActive == 1 &&
                _entityDetails[0].subscriptionInfo &&
                _entityDetails[0].subscriptionInfo != null &&
                _entityDetails[0].subscriptionInfo != 'null'
              "
            >
              <p><mat-icon>check_circle</mat-icon> This business is active</p>
            </div>
            <div
              class="inactive_cardt"
              *ngIf="
                _entityDetails[0].isActive == 1 &&
                (!_entityDetails[0].subscriptionInfo ||
                  !_entityDetails[0].subscriptionInfo == null ||
                  _entityDetails[0].subscriptionInfo == 'null')
              "
            >
              <p>
                <mat-icon>cancel</mat-icon> Subscription expired for this
                business
              </p>
            </div>
            <div class="inactive_cardt" *ngIf="_entityDetails[0].isActive == 0">
              <p><mat-icon>cancel</mat-icon> This business is inactive</p>
            </div>
          </div>

          <div *ngIf="_entityDetails[0].is_owner == 0">
            <div
              class="active_cardt"
              *ngIf="
                _entityDetails[0].employee_entry_type &&
                _entityDetails[0].employee_entry_type != null &&
                _entityDetails[0].employee_entry_type != 'null' &&
                _entityDetails[0].employee_entry_type == 1
              "
            >
              <p>
                <mat-icon>check_circle</mat-icon> Duty started at
                {{
                  _entityDetails[0].employee_duty_time
                    | date: "h:mm a, d MMMM y " : "UTC"
                }}
              </p>
            </div>
            <div
              class="inactive_cardt"
              *ngIf="
                !_entityDetails[0].employee_entry_type ||
                _entityDetails[0].employee_entry_type == null ||
                _entityDetails[0].employee_entry_type == 'null' ||
                _entityDetails[0].employee_entry_type == 0
              "
            >
              <p><mat-icon>cancel</mat-icon> You are off-duty right now</p>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
